import * as React from "react";
import { List, Icon, Descriptions, Button } from "antd";
import { FormattedProductType } from "../Localisation/FormattedProductType";
import { StreamingTradingAccountResources } from "../TradingAccountResources/StreamingTradingAccountResources";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { TradingAccount } from "swan-public-api-client";
import { FormattedCurrency } from "../Localisation/FormattedCurrency";

interface Props extends WrappedComponentProps {
  tradingAccount: TradingAccount;
  onTradingAccountSelected: (tradingAccount: TradingAccount) => void;
}

class AccountSelectorTradingAccountListItemCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <List.Item>
        <Icon type="user" />
        <div>{this.props.tradingAccount.AccountCode}</div>
        <div><FormattedProductType value={this.props.tradingAccount.AccountType} /></div>
        <div className="trading-account-resources">
          <StreamingTradingAccountResources groupKey={this.props.tradingAccount.Key}>
            {(currency, tradingAccountResources) =>
              <Descriptions>
                <Descriptions.Item label={this.props.intl.formatMessage({ id: "tradingAccountResources.openPnL" })}><FormattedCurrency value={tradingAccountResources ? tradingAccountResources.OpenPnl : undefined} currency={currency} /></Descriptions.Item>
                <Descriptions.Item label={this.props.intl.formatMessage({ id: "tradingAccountResources.netOpenPositions" })}><FormattedCurrency value={tradingAccountResources ? tradingAccountResources.NetOpenPosition : undefined} currency={currency} /></Descriptions.Item>
              </Descriptions>
            }
          </StreamingTradingAccountResources>
        </div>
        <div>
          <Button
            type="primary"
            icon="select"
            onClick={() => this.props.onTradingAccountSelected(this.props.tradingAccount)}>
            {this.props.intl.formatMessage({ id: "accountSelector.selectTradingAccountButton" })}
          </Button>
        </div>
      </List.Item>
    );
  }
}

export const AccountSelectorTradingAccountListItem = injectIntl(AccountSelectorTradingAccountListItemCmp);